import client from '@/config/directus.api';

export class User {
  constructor(data) {
    this.id = data.id;
    this.title = data.title;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.email = data.email;
    this.locale = data.locale || 'de-DE';
    this.accept_privacy_policy = data.accept_privacy_policy || false;
    this.company = data.company;
  }
}

export function getMe() {
  return client
    .getMe({
      fields: ['*', 'role.name', 'company.*', 'company.logo.*.*', 'company.logo_black.*.*', 'company.logo_white.*.*', 'modules.module.*']
    })
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

export function updateUserById(id, payload) {
  const user = new User(payload);
  return client
    .updateUser(id, user)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/*
 * ROLES
 */
export const ROLE_ADMIN = 'Administrator';
export const ROLE_MEMBER = 'Member';
